module.exports = __webpack_public_path__ + "static/media/zoleLose_100_250.c790ce70.png";